const MULTIMONEDA_SLUGS = ['profesional', 'empresarial', 'enterprise'];

export function hasMultimoneda(user) {
  if (!user) return false;
  const slug = String(user?.currentPlan?.slug || '').toLowerCase();
  if (MULTIMONEDA_SLUGS.includes(slug)) return true;
  if (user?.currentPlan?.features?.multimoneda) return true;
  if (user?.unlockedFeatures?.multimoneda) return true;
  return false;
}

export const MONEDA_OPTIONS = [
  { value: 'ARS', label: 'ARS — Pesos' },
  { value: 'USD', label: 'USD — Dólares' },
  { value: 'EUR', label: 'EUR — Euros' },
];

export function monedaOptionsForUser(user) {
  if (hasMultimoneda(user)) return MONEDA_OPTIONS;
  return MONEDA_OPTIONS.filter((o) => o.value === 'ARS');
}
